const maskedNumberFieldFormatter = (value) => value.replace(/\D/g, '');

export default maskedNumberFieldFormatter;
